<template>
  <ClickToJump :message="$t('pc_biz_ote_click_to_practice' /* 好的,正在为您唤起创建练习页面 */)" :target-url="targetUrl" :datas="datas" />
</template>
 
<script>
import ClickToJump from '../common/click-to-jump.vue';
import CommonMixin from '../common/props-mixin';

export default {
  name: 'CreatePractice',
  components: {
    ClickToJump
  },
  mixins: [CommonMixin],
  data() {
    return {
      targetUrl: `${window.location.origin}/ote/#/quickexam/create/practice?examType=practice`
    };
  }
};
 </script>